<template>
    <div class="home-container">
        <HomeContentClassic
            v-if="!qrcodeObject.project.isUsingLandingFullHtml && !customHtml"
            :displayRecordButton="!contentBanned && !isShortlinkBurnt && !isCommentingAllowed"
            :displayTextResponseButton="isCommentingAllowed"
            :displayEditButton="canEditExperience && !reportedOrBanned"
            :displayShareButton="
                isShortlinkBurnt && $t('general.share').length > 0 && !reportedOrBanned
            "
            :displayDownloadButton="isShortlinkBurnt && !canEditExperience && !reportedOrBanned"
            :onVideoPick="onVideoPick"
            :openReplyVideo="openReplyVideoModal"
            :share="share"
            :downloadVideo="downloadVideo"
            :videoUrl="fullVideoUrl"
            :adminUrl="adminUrl"
            @error="onError"
            @report-btn-clicked="openReportPopin"
        />
        <HomeContentCustom
            v-if="
                (!qrcodeObject.project.isUsingLandingFullHtml && customHtml.length > 0) ||
                    (qrcodeObject.project.isUsingLandingFullHtml && customFullHtml.length > 0)
            "
            :displayRecordButton="!contentBanned && !isShortlinkBurnt && !isCommentingAllowed"
            :displayTextResponseButton="isCommentingAllowed"
            :displayEditButton="canEditExperience"
            :displayShareButton="
                isShortlinkBurnt && $t('general.share').length > 0 && !reportedOrBanned
            "
            :displayDownloadButton="isShortlinkBurnt && !canEditExperience && !reportedOrBanned"
            :goToRecord="goToRecord"
            :onVideoPick="onVideoPick"
            :openReplyVideoModal="openReplyVideoModal"
            :share="share"
            :downloadVideo="downloadVideo"
            :contentBanned="contentBanned"
            :videoUrl="fullVideoUrl"
            :webarUrl="webArUrl"
            :adminUrl="adminUrl"
            :htmlContent="qrcodeObject.project.isUsingLandingFullHtml ? customFullHtml : customHtml"
            :jsContent="customJs"
            @report-btn-clicked="openReportPopin"
        />
        <span class="banzai main"></span>
        <span class="banzai red"></span>
        <span class="banzai light"></span>
        <span class="banzai dark"></span>
        <!--
        <transition name="fade" appear>
            <div v-if="permissionError" class="permission-error-message">
                {{ $t("general.motionPermissionRefused") }}
            </div>
        </transition>
        -->
        <ReportContentPopin
            v-if="displayReportContentPopin"
            @close="closeReportPopin"
            :qrcodeObject="qrcodeObject"
            :videoUrl="fullVideoUrl"
        />
        <Message
            class="message-popin"
            v-if="isMessage"
            :isError="messageOverlay.isError"
            :info="messageOverlay.info"
            :title="messageOverlay.title"
            :text="messageOverlay.text"
            :isCompliant="messageOverlay.isCompliant"
            :allowCopy="messageOverlay.allowCopy"
            @close="isMessage = false"
        />
        <transition name="fade">
            <ReplyModal
                v-if="isReplyOpen"
                :replyToVideo="replyToVideo"
                @close="isReplyOpen = false"
            />
        </transition>
        <transition name="fade">
            <Loader size="40px" class="ar-loader" v-if="isGoingToAR" />
        </transition>
    </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import JsFileDownload from "js-file-download";
import axios from "axios";
import { State } from "@/store";
import { isIOS, canNativeShare, nativeShare } from "@/utils";
import Message from "@/components/Message.vue";
import ReplyModal from "@/components/ReplyModal.vue";
import HomeContentClassic from "./HomeContentClassic.vue";
import HomeContentCustom from "./HomeContentCustom.vue";
import Loader from "@/components/Loader.vue";
import ReportContentPopin from "@/components/ReportContentPopin.vue";
import { ErrorStatus } from "@/typings/Error";
import { getApiEndpoints } from "@/utils/utils";

export default {
    name: "Home",
    components: {
        Message,
        HomeContentClassic,
        HomeContentCustom,
        Loader,
        ReportContentPopin,
        ReplyModal
    },
    data() {
        return {
            isGoingToAR: false,
            messageOverlay: {},
            isMessage: false,
            isReplyOpen: false,
            permissionError: false,
            displayReportContentPopin: false,
            isIOS: isIOS()
        };
    },
    computed: {
        contentBanned() {
            return false; // TO DO => replace by value when BE part will be done
        },
        contentReported() {
            return false; // TO DO => replace by value when BE part will be done
        },
        reportedOrBanned() {
            return this.contentReported || this.contentBanned;
        },
        isShortlinkBurnt() {
            return this.qrcodeObject.isBurnt;
        },
        isCommentingAllowed() {
            return this.qrcodeObject.project.isCommentable || false;
        },
        canEditExperience() {
            return (
                this.authenticated &&
                this.isShortlinkBurnt
            );
        },
        fullVideoUrl() {
            let url = this.videoUrl;
            if (!url) {
                return "";
            }
            if (!url.startsWith("http")) {
                url = getApiEndpoints().API_BASE + url;
            }
            return isIOS() ? url + "#t=0.5" : url;
        },
        adminUrl() {
            return (
                getApiEndpoints().ADMIN_URL +
                (this.$store.state.auth.sessionToken.length
                    ? "?session=" + this.$store.state.auth.sessionToken
                    : "")
            );
        },
        webArUrl(){
            return this.webarurl;
        },
        ...mapState({
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject,
            videoUrl: (state: State) => state.qrcode.videoUrl,
            customHtml: (state: State) => state.qrcode.customHtml,
            customFullHtml: (state: State) => state.qrcode.customFullHtml,
            customJs: (state: State) => state.qrcode.customJs,
            qrcodeError: (state: State) => state.qrcode.error,
            hasRecordedExperience: (state: State) => state.record.videoFile !== null,
            authenticated: (state: State) => state.auth.authenticated,
            userId: (state: State) => state.auth.userId,
            webarurl: (state: State) => state.qrcode.webarUrl,
        })
    },
    beforeUnmount() {
        Array.from(document.getElementsByClassName("banzai")).forEach(element => {
            element.classList.remove("expanded");
        });
    },
    methods: {
        checkCompatibility() {
            /*
            let isWasm;
            if (typeof WebAssembly === "object" && typeof WebAssembly.instantiate === "function") {
                const module = new WebAssembly.Module(
                    Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00)
                );
                if (module instanceof WebAssembly.Module)
                    isWasm = new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
            }
            */
            const navAgent = navigator.userAgent;
            const forbiddenStrings = ["FBAN", "FBAV"];
            const isAllowedApp = forbiddenStrings.findIndex(str => navAgent.includes(str)) === -1;
            const isVideo = "mediaDevices" in navigator && "getUserMedia" in navigator.mediaDevices;
            return isAllowedApp && isVideo;
        },
        showMessage(_isError, title, text, isCompatible = true, allowCopy = false) {
            this.messageOverlay = {
                isError: _isError,
                title: title,
                text: text,
                isCompliant: isCompatible,
                allowCopy
            };
            if (_isError) {
                console.error(text);
            }

            this.isMessage = true;
        },
        onError(status) {
            if (status === ErrorStatus.Timeout) {
                this.showMessage(
                    true,
                    this.$t("errors.timeout"),
                    this.$t("errors.videoConnectionProblems")
                );
            }
            if (status === ErrorStatus.LoadError) {
                this.showMessage(
                    true,
                    this.$t("errors.serverErrorTitle"),
                    this.$t("errors.videoConnectionProblems")
                );
            }
        },

        onServerError() {
            console.log("onServerError");
            this.showMessage(
                true,
                "Erreur serveur",
                "Problème de connexion à notre serveur QRCode"
            );
        },

        goToRecord() {
            this.$router.push("Record");
        },

        onVideoPick(event: Event) {
            const file = (event.target as HTMLInputElement).files[0];

            this.$store.dispatch("record/setRecordedVideo", {
                videoFile: file,
                videoName: file.name
            });
            this.$router.push("Record");
        },

        openReplyVideoModal() {
            this.isReplyOpen = true;
        },

        async replyToVideo(message: string, firstName: string, lastName: string) {
            const url = getApiEndpoints().COMMENTS;

            const formData = new FormData();
            formData.append("shortlink_id", this.qrcodeObject.shortlink.id.toString());
            formData.append("text", message);
            formData.append("first_name", firstName);
            formData.append("last_nme", lastName);

            try {
                const result = await axios.post(url, formData);

                if (result.status === 200) {
                    this.showMessage(false, this.$t("success.done"), this.$t("reply.replySent"));
                }

                return result;
            } catch (error) {
                this.showMessage(
                    true,
                    this.$t("errors.serverErrorTitle"),
                    error?.message || this.$t("errors.videoConnectionProblems")
                );
                return error;
            }
        },

        share() {
            const shareTitle = this.isShortlinkBurnt
                ? this.$t("share.openTitle")
                : this.$t("share.burnedTitle");
            // project name
            const shareText = this.isShortlinkBurnt
                ? this.$t("share.openText")
                : this.qrcodeObject.project.name;

            if (canNativeShare()) {
                nativeShare(shareTitle, shareText, document.location.href.split("#")[0]);
            } else {
                this.showMessage(
                    false,
                    this.$t("general.share"),
                    `${shareText} ${document.location.href.split("#")[0]}`,
                    true,
                    true
                );
            }
        },

        downloadVideo() {
            axios({
                method: "GET",
                url: this.fullVideoUrl,
                responseType: "blob"
            }).then(response => {
                JsFileDownload(response.data, "stqr video.mp4", response.headers["content-type"]);
            });
        },

        switchLocale(locale) {
            this.$i18n.locale = locale;
        },

        openReportPopin() {
            document.body.classList.add("noscroll");
            this.displayReportContentPopin = true;
        },

        closeReportPopin() {
            document.body.classList.remove("noscroll");
            this.displayReportContentPopin = false;
        }
    }
};
</script>
<style scoped>
.home-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.permission-error-message {
    padding: 20px;
    color: var(--red);
    font-weight: 500;
}

.banzai {
    display: block;
    width: 0;
    height: 0;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    z-index: 50;
    transition: 0.8s ease;
    border-radius: 50%;
    background-color: transparent;
}

.banzai.expanded {
    width: 250%;
    padding-bottom: 250%;
    height: auto;
}

.banzai.main {
    background-color: var(--primary);
    filter: saturate(1000%);
}
.banzai.dark {
    background-color: var(--secondary);
}
.banzai.light {
    background-color: var(--primary);
}
.banzai.red {
    background-color: var(--red);
}

.banzai:nth-of-type(1) {
    transition-delay: 0.25s;
}
.banzai:nth-of-type(2) {
    transition-delay: 0.5s;
}
.banzai:nth-of-type(3) {
    transition-delay: 0.75s;
}
.banzai:nth-of-type(4) {
    transition-delay: 1s;
}

.ar-loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
}
</style>
